import React from 'react';
import { Box } from '@mui/material';
export default function Index({
    color,
    size,
    width = '20px',
    height = '20px',
    ...other
}) {
    return (
        <Box
            component="svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            color={color ? color : 'primaryText'}
            {...other}
        >
            <path
                stroke="currentColor"
                strokeWidth={1.5}
                d="M12.432 5.841c0 1.307-1.11 2.471-2.432 2.471-1.323 0-2.432-1.164-2.432-2.47C7.568 4.498 8.711 3.25 10 3.25s2.432 1.249 2.432 2.591Zm4.318 8.14c0 .62-.341 1.279-1.386 1.824-1.07.557-2.809.945-5.364.945-2.555 0-4.293-.388-5.364-.945C3.591 15.26 3.25 14.6 3.25 13.982c0-.51.469-1.201 1.765-1.81 1.237-.58 2.999-.959 4.985-.959 1.986 0 3.748.38 4.985.96 1.296.608 1.765 1.3 1.765 1.809Z"
            />
        </Box>
    );
}
